<template>
  <div class="ccui-error-305-main">
    <div class="ccui-error-305__pic">
      <img
        src="@/basa/assets/305_images/305.png"
        alt="305"
        width="579px"
        height="291px"
      />
    </div>
    <div class="ccui-error-305-detail">
      <div class="ccui-error-305-detail-text">
        {{ $store.state.app.routerPower.message }}
      </div>
      <div class="ccui-error-305-detail-button">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error305",
  data() {
    return {};
  },
  methods: {
    goBack() {
      window.location.href = this.$addUrlPerFix(process.env.VUE_APP_EMP_URL);
    }
  }
};
</script>
